import React, { useEffect, useState } from "react";
import { postApi } from "../api";
import SearchBar from "../components/SearchBar";
import CourseCard from "../components/CourseCard";

const Catalogo = () => {
    const [cursos, setCursos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const cargar = (texto) => {
        setLoading(true);
        setError(false);
        postApi("/free/cursos/list", { texto })
            .then((data) => setCursos(data.rows || []))
            .catch(() => setError(true))
            .finally(() => setLoading(false));
    };

    useEffect(() => { cargar(); }, []);

    return (
        <div className="catalogo">
            <section className="hero">
                <h1>Aprende algo nuevo hoy</h1>
                <p>Explora nuestros cursos disponibles</p>
                <SearchBar onSearch={cargar} />
            </section>

            {loading && <p className="estado-msg">Cargando cursos...</p>}
            {error && <p className="estado-msg error">No se pudo cargar el catálogo. Intenta de nuevo más tarde.</p>}
            {!loading && !error && cursos.length === 0 && (
                <p className="estado-msg">No hay cursos publicados por el momento.</p>
            )}

            <div className="course-grid">
                {cursos.map((c) => (
                    <CourseCard key={c.id_rs} curso={c} />
                ))}
            </div>
        </div>
    );
};

export default Catalogo;
